import { Button } from '@cian/ui-kit';

import { type FC, type JSX, useCallback } from 'react';

import { ChatButtonRendererContainer } from './ChatButtonRendererContainer';

export const CardChatButtonWideContainer: FC = () => {
  const render = useCallback(
    ({ onClick, loading }: { onClick: () => void; loading: boolean }): JSX.Element => (
      <Button
        fullWidth
        data-testid="card.chat-button"
        loading={loading}
        size="XS"
        theme="fill_secondary"
        onClick={onClick}
      >
        Написать
      </Button>
    ),
    [],
  );

  return <ChatButtonRendererContainer render={render} />;
};
